"use client";
import React, {
  useState,
  useEffect,
  useCallback,
  useContext,
  useRef,
} from "react";
import dynamic from "next/dynamic";
import Image from "next/image";
import { useSelector, useDispatch } from "react-redux";
import { LoaderContext } from "@/contexts/LoaderContext";
import { Button, Col, Container } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper/modules";
// ✅ Dynamically import heavier components
const CategoryCard = dynamic(() => import("@/components/category-card"), {
  ssr: false,
});
const ServiceCard = dynamic(() => import("@/components/service-card"), {
  ssr: false,
});
const SectionHeading = dynamic(() => import("@/components/section-heading"), {
  ssr: false,
});
const ProductCardMain = dynamic(
  () => import("@/components/product-card/productcard-main"),
  { ssr: false }
);
const ProductCardSub = dynamic(
  () => import("@/components/product-card/productcard-sub"),
  { ssr: false }
);
const WatchAndShopCard = dynamic(
  () => import("@/components/watch-and-shop-card"),
  { ssr: false }
);
const PopularCard = dynamic(() => import("@/components/popular-card"), {
  ssr: false,
});
const BlogCard = dynamic(() => import("@/components/blog-card"), {
  ssr: false,
});
const CustomerFeedbackCard = dynamic(
  () => import("@/components/customer-feedback-card"),
  { ssr: false }
);
const QuickLookPopup = dynamic(() => import("@/components/quick-look-popup"), {
  ssr: false,
});
// const ComanButton = dynamic(() => import("@/components/coman-button"), {
//   ssr: false,
// });
const CommonBtn = dynamic(() => import("@/components/buttons/CommonBtn"), {
  ssr: false,
});

import {
  cetegorycard,
  servicecard,
  sareecontent,
  whatandshopcontent,
  popularproduct,
  casualwearcontent,
  latestarrivalcontent,
  tunicandcordsetcontent,
  blogcontent,
  customerfeedbackcontent,
} from "@/constants/home";

import { fetchAllGroups, fetchCategories } from "@/redux/slices/categorySlice";
import {
  clearProduct,
  fetchLatestProducts,
  fetchPopularProducts,
  fetchProductById,
  fetchProducts,
  fetchProductsByGroup,
} from "@/redux/slices/productSlice";
import { fetchVideos } from "@/redux/slices/watchAndBuySlice";
import { fetchBlogs } from "@/redux/slices/blogSlice";
import { RightArrowIcon } from "@/components/icons/common-button-icon";
import Link from "next/link";
import ReelPopup from "@/components/reel-poup";
import CustomCarousel from "@/components/custom-carousel/CustomCarousel";
import { isOdd } from "@/utility/utility";

export default function Home() {
  const { showLoader, hideLoader } = useContext(LoaderContext);
  const prevRef = useRef(null);
  const nextRef = useRef(null);
  const casualprevRef = useRef(null);
  const casualnextRef = useRef(null);
  const [countdown, setCountdown] = useState({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0,
  });
  const dispatch = useDispatch();
  const category = useSelector((state) => state.categories.categories);

  const allGroups = useSelector((state) => state.categories.allGroups);
  const { product } = useSelector((state) => state.products);
  const videos = useSelector((state) => state.watchAndBuy.videos);
  // console.log("videos", videos);

  const blogs = useSelector((state) => state.blogs.blogs.data);

  const [showQuickLook, setShowQuickLook] = useState(false);
  const [selectedProduct, setSelectedProduct] = useState(null);
  const productsByGroup = useSelector(
    (state) => state.products.productsByGroup
  );
  const [groupedProducts, setGroupedProducts] = useState({});
  const [reelModal, setReelModal] = useState(false);
  const [activeReel, setActiveReel] = useState(null); // <- track index instead of object
  const handleReelModal = useCallback((idx) => {
    setActiveReel(idx);
    setReelModal(true);
  }, []);

  const closeReelModal = useCallback(() => {
    setReelModal(false);
  }, []);

  // const nextReel = useCallback(() => {
  //   if (!videos?.data?.length) return;

  //   setActiveReel((prev) =>
  //     prev === null ? 0 : (prev + 1) % videos.data.length
  //   );
  // }, [videos?.data?.length]); // ✅ dependency added

  // const prevReel = useCallback(() => {
  //   if (!videos?.data?.length) return;

  //   setActiveReel((prev) =>
  //     prev === null ? 0 : (prev - 1 + videos.data.length) % videos.data.length
  //   );
  // }, [videos?.data?.length]); // ✅ dependency added

  // useEffect(() => {
  //   if (allGroups?.data?.length) {
  //     const fetchProductsForGroups = async () => {
  //       showLoader();
  //       let productsData = {};

  //       await Promise.all(
  //         allGroups.data.map(async (group) => {
  //           const response = await dispatch(fetchProductsByGroup(group.group_id));
  //           if (response.payload) {
  //             productsData[group.group_name] = response.payload;
  //           }
  //         })
  //       );

  //       setGroupedProducts(productsData);
  //       hideLoader();
  //     };

  //     fetchProductsForGroups();
  //   }
  // }, [allGroups, dispatch, showLoader, hideLoader]);

  const handleQuickLook = async (productId) => {
    dispatch(clearProduct());
    const res = await dispatch(fetchProductById(productId));
    if (res.payload) {
      setSelectedProduct(productId);
      setShowQuickLook(true);
    }
  };

  const handleCloseQuickLook = () => {
    setShowQuickLook(false);
    setSelectedProduct(null);
  };

  useEffect(() => {
    const countDownDate = new Date("Dec 30, 2027 11:59:59").getTime();

    const interval = setInterval(() => {
      // Get today's date and time
      const now = new Date().getTime();

      // Find the distance between now and the count down date
      const distance = countDownDate - now;

      // Time calculations for days, hours, minutes, and seconds
      const days = Math.floor(distance / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((distance % (1000 * 60)) / 1000);

      // Format the countdown string
      setCountdown({
        days: days,
        hours: hours,
        minutes: minutes,
        seconds: seconds,
      });
      // Update the state
      // setCountdown(countdownString);

      // If the count down is over, clear the interval
      if (distance < 0) {
        clearInterval(interval);
        setCountdown("EXPIRED");
      }
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  const fetchInitialData = useCallback(async () => {
    try {
      showLoader();

      // Fetch all groups
      const groupResponse = await dispatch(fetchAllGroups());

      if (groupResponse.payload?.data) {
        const groups = groupResponse.payload.data;
        const productsData = {};

        // Fetch products for all groups concurrently
        await Promise.all(
          groups.map(async (group) => {
            const productResponse = await dispatch(
              fetchProductsByGroup(group.group_id)
            );
            if (productResponse.payload) {
              productsData[group.group_name] = productResponse.payload;
            }
          })
        );

        setGroupedProducts(productsData);
      }

      // Fetch additional data concurrently
      await Promise.all([
        dispatch(fetchVideos()),
        dispatch(fetchBlogs()),
        dispatch(fetchProducts({ latest: true })),
        dispatch(fetchProducts({ popular: true })),
      ]);
    } catch (error) {
      // console.error("Error fetching initial data:", error);
      hideLoader();
    } finally {
      hideLoader();
    }
  }, [dispatch]);

  // Call it explicitly when needed
  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const latestProducts = useSelector((state) => state.products.latestProducts);
  const popularProducts = useSelector(
    (state) => state.products.popularProducts
  );

  const [sareeProducts, setSareeProducts] = useState([]);
  const [casualWearProducts, setCasualWearProducts] = useState([]);
  const [cordSetProducts, setCordSetProducts] = useState([]);

  useEffect(() => {
    if (allGroups?.data?.length) {
      allGroups.data.forEach((group) => {
        if (group.group_name === "Saree Sansination") {
          dispatch(fetchProductsByGroup(group.group_id)).then((response) => {
            if (response.payload) {
              setSareeProducts(response.payload);
            }
          });
        }

        if (group.group_name === "Casual Wear") {
          dispatch(fetchProductsByGroup(group.group_id)).then((response) => {
            if (response.payload) {
              setCasualWearProducts(response.payload);
            }
          });
        }

        if (group.group_name === "Cord Set & Tunic") {
          dispatch(fetchProductsByGroup(group.group_id)).then((response) => {
            if (response.payload) {
              setCordSetProducts(response.payload);
            }
          });
        }
      });
    }
  }, [allGroups, dispatch]);

  const [startIndex, setStartIndex] = useState(0);
  const visibleCardsCount =
    window.innerWidth >= 1400
      ? 6
      : window.innerWidth >= 1200
      ? 5
      : window.innerWidth >= 992
      ? 4
      : window.innerWidth >= 768
      ? 3
      : window.innerWidth >= 576
      ? 2
      : 1;

  const handleSwipeLeft = () => {
    if (startIndex > 0) {
      setStartIndex(startIndex - 1);
    }
  };

  const handleSwipeRight = () => {
    if (startIndex + visibleCardsCount < category?.data?.length) {
      setStartIndex(startIndex + 1);
    }
  };

  const visibleCards = category?.data?.slice(
    startIndex,
    startIndex + visibleCardsCount
  );

  return (
    <div>
      {/* ------- Category Section Start ------- */}
      <section className="mx-xxl-1 px-4">
        <div className=" d-flex home-content">
          <CategoryCard categorycard_data={visibleCards} className="" />
        </div>
        <div className=" w-100 mt-4 d-flex d-xxl-none align-items-center  gap-3 justify-content-center ">
          {/* <span>left</span>
          <span>right</span> */}
          <button
            onClick={handleSwipeLeft}
            className="p-0 rounded-circle d-flex align-items-center justify-content-center border-0 bg-green-icon slider-btn"
            aria-label="Swipe-left"
          >
            <svg
              width={20}
              height={20}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M15 6L9 12L15 18"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeMiterlimit={16}
              />
            </svg>
          </button>
          <button
            onClick={handleSwipeRight}
            className="p-0 rounded-circle d-flex align-items-center justify-content-center border-0 bg-green-icon slider-btn"
            aria-label="Swipe-right"
          >
            <svg
              width={20}
              height={20}
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M9.00005 6L15 12L9 18"
                stroke="#ffffff"
                strokeWidth="1.5"
                strokeMiterlimit={16}
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        </div>
      </section>
      {/* ------- Category Section End ------- */}

      {/* ------- Service Section Start ------- */}
      <section className="section-py position-relative">
        <Image
          src="/assets/images/whatsnew/service/circle-shape.svg"
          className=" position-absolute d-none d-xl-block ms-auto service-circle-shape w-auto h-auto"
          fill
          alt="Circle Shape Image "
          sizes="(min-width: 1200px) 200px, 100vw"
        />
        <Container>
          <div className="grid service-gap">
            <ServiceCard
              servicecard_data={servicecard}
              className="g-col-12 g-col-sm-6 g-col-xl-3"
            />
          </div>
        </Container>
      </section>
      {/* ------- Service Section End ------- */}

      {/* ------- Saree Sansination Section Start ------- */}
      {groupedProducts["Saree Sansination"]?.products?.length > 0 && (
        <section className="saree-sensation-gradient section-py position-relative">
          <div className="line-shape"></div>
          <Container className="pb-5 pb-sm-0">
            <div className="d-flex align-items-center justify-content-between ">
              <SectionHeading
                title="Saree Sensation"
                className="fuchsia-layer"
              />

              {groupedProducts["Saree Sansination"]?.products?.length > 5 && (
                <div className="d-flex align-items-center gap-3 justify-content-between saree-carousel">
                  <div className="d-none d-sm-block">
                    {/* <ComanButton
                      title="All Products"
                      type="arrowshow"
                      href="/saree"
                    /> */}
                    <CommonBtn
                      variant="hover-outline"
                      as={Link}
                      href="/saree"
                      className="d-flex align-items-center position-relative px-3"
                    >
                      <span
                        className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                      >
                        All Products
                      </span>
                      <RightArrowIcon className="z-1" size={22} />
                    </CommonBtn>
                  </div>
                  <button
                    className="swiper-button-prev position-static d-flex align-items-center justify-content-center border-0"
                    ref={prevRef}
                  ></button>

                  <button
                    className="swiper-button-next position-static d-flex align-items-center justify-content-center border-0"
                    ref={nextRef}
                  ></button>
                </div>
              )}
            </div>
            <div className="pt-4 mt-1">
              <Swiper
                className="mySwiper"
                slidesPerView={5}
                loop={true}
                navigation={{
                  prevEl: prevRef.current,
                  nextEl: nextRef.current,
                }}
                onBeforeInit={(swiper) => {
                  swiper.params.navigation.prevEl = prevRef.current;
                  swiper.params.navigation.nextEl = nextRef.current;
                }}
                modules={[Navigation, Autoplay]}
                autoplay={{
                  delay: 3000, // time in ms between slides
                  disableOnInteraction: false, // continue autoplay after user interactions
                }}
                breakpoints={{
                  0: {
                    slidesPerView: 1,
                    centeredSlides: true,
                  },
                  640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                    centeredSlides: false,
                  },
                  768: {
                    slidesPerView: 3,
                    spaceBetween: 24,
                  },
                  1200: {
                    slidesPerView: 4,
                    spaceBetween: 24,
                  },
                  1640: {
                    slidesPerView: 5,
                    spaceBetween: 24,
                  },
                }}
              >
                {groupedProducts["Saree Sansination"]?.products?.length > 0 ? (
                  groupedProducts["Saree Sansination"]?.products?.map(
                    (group, i) => {
                      return (
                        <>
                          <SwiperSlide key={`${i}`}>
                            <ProductCardMain
                              products={group}
                              classNam={"cursor-pointer"}
                              type="carouselview"
                              onClick={handleQuickLook}
                            />
                          </SwiperSlide>
                        </>
                      );
                    }
                  )
                ) : (
                  <div className="d-flex justify-content-center align-items-center py-5">
                    <h2 className="text-muted">No Products Found</h2>
                  </div>
                )}
              </Swiper>
            </div>
          </Container>
        </section>
      )}

      {/* ------- Saree Sansination Section End ------- */}

      {/* ------- Watch & Buy Section Start ------- */}
      {videos?.data?.length > 0 && (
        <section className="section-py position-relative watch-and-shop">
          <Image
            src="/assets/images/whatsnew/watchandshop/reel-shape.webp"
            className="position-absolute d-none d-xl-block object-fit-cover m-0 z-n1 bottom-0 end-0"
            width={294}
            height={464}
            alt="Shape Image"
          />
          <Image
            src="/assets/images/whatsnew/watchandshop/reel-icon-shape.webp"
            className="position-absolute d-none d-xl-block object-fit-cover z-n1 w-auto start-0 top-0 translate-middle-y"
            width={85}
            height={111}
            alt="Reel Icon Image"
          />

          <Container fluid="xxl">
            <div className="text-center">
              <SectionHeading title="Watch & Buy" className="yellow-layer" />
            </div>

            <div className="pt-4 mt-1">
              <CustomCarousel
                autoplay={{
                  delay: 3000, // 3 seconds
                  disableOnInteraction: false, // keeps autoplay even after user interaction
                }}
                className="mx-auto"
                items={videos?.data || []}
                slidesPerView={6}
                loop={true}
                breakpoints={{
                  0: { slidesPerView: 1, spaceBetween: 8 },
                  460: { slidesPerView: 2, spaceBetween: 12 },
                  768: { slidesPerView: 3, spaceBetween: 12 },
                  992: { slidesPerView: 4, spaceBetween: 12 },
                  1200: { slidesPerView: 4, spaceBetween: 12 },
                  1400: { slidesPerView: 5, spaceBetween: 12 },
                  1640: { slidesPerView: 6, spaceBetween: 12 },
                }}
                renderItem={(item, i) => (
                  <WatchAndShopCard
                    data={item}
                    key={i}
                    // onClick={() => openReel(item, i)}
                    onClick={() => handleReelModal(i)}
                  />
                )}
                alterClass="justify-content-center"
              />
            </div>
          </Container>
        </section>
      )}
      {/*  */}
      {/* ------- Watch & Buy Section End ------- */}

      {/* ------- Popular of Kalindi Section Start ------- */}
      {popularProducts?.products?.length > 0 && (
        <section className="popular-kalindi-content section-py position-relative white-space-pd">
          <div className="line-shape z-n1"></div>
          <Container fluid="lg" className="overflow-hidden">
            <div className="d-flex align-items-center  justify-content-between">
              <SectionHeading
                title="Popular of Kalindi"
                className="cyan-layer"
              />
              <div className="d-none d-sm-block">
                {/* <ComanButton
                  title="All Products"
                  type="arrowshow"
                  href="/popular-products"
                />   */}
                <CommonBtn
                  variant="hover-outline"
                  as={Link}
                  href="/popular-products"
                  className="d-flex align-items-center position-relative px-3"
                >
                  <span
                    className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                  >
                    All Products
                  </span>
                  <RightArrowIcon className="z-1" size={22} />
                </CommonBtn>
              </div>
            </div>
            <div className="pt-4 mt-1">
              <div className="d-flex flex-column flex-xl-row align-items-stretch popular-kalindi-subcontent">
                {/* When there is no popular offer, the following will be displayed. */}
                <div>
                  <Image
                    src="/assets/images/whatsnew/popularofkalindi/product/popular-main.svg"
                    className="h-auto w-auto d-none d-xl-block position-static"
                    fill
                    loading="lazy"
                    alt="Popular Kalindi Image "
                  />
                  <Image
                    src="/assets/images/whatsnew/popularofkalindi/product/poster-main-tab.svg"
                    className=" d-block d-xl-none position-static object-fit-cover tab-img"
                    fill
                    loading="lazy"
                    alt="Popular Kalindi Image "
                  />
                </div>

                {/* The following will be displayed when there is a popular offer. */}
                {/* <div className="position-relative ">
                  <Image
                    src="/assets/images/whatsnew/popularofkalindi/product/main.svg"
                    className="h-auto w-auto d-none d-xl-block position-static"
                    fill
                    alt="Popular Kalindi Image "
                  />
                  <Image
                    src="/assets/images/whatsnew/popularofkalindi/product/main-tabs.svg"
                    className=" d-block d-xl-none position-static object-fit-cover tab-img"
                    fill
                    alt="Popular Kalindi Image "
                  />
                  <div className="position-absolute top-0 bottom-0 start-0 end-0">
                    <div className="popularkalindi-layer d-flex flex-column justify-content-center d-xl-block">
                      <div className="layer-text">
                        <p className="fw-normal">Buy 3 Products & Get</p>
                        <span className="fw-medium">10% OFF</span>
                      </div>
                      <div className="layer-btn ">
                        <ComanButton
                          title="Shop Now"
                          type="arrowshow"
                          href=""
                        />
                      </div>
                    </div>
                  </div>
                </div> */}

                {/* ------------------- */}
                <div className="row gy-4 cards-cover">
                  <PopularCard
                    data={popularProducts?.products}
                    className="col-12 col-sm-6"
                  />
                </div>
                <div className="text-center d-sm-none">
                  {/* <ComanButton title="All Products" type="arrowshow" href="#" /> */}
                  <CommonBtn
                    variant="hover-outline"
                    // as={Link}
                    // href="/tunic-cord-set-products"
                    className="d-flex align-items-center position-relative px-3"
                  >
                    <span
                      className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                    >
                      All Products
                    </span>
                    <RightArrowIcon className="z-1" size={22} />
                  </CommonBtn>
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* ------- Popular of Kalindi Section End ------- */}

      {/* ------- Casual Wear Section End ------- */}
      {groupedProducts["Casual Wear"]?.products?.length > 0 > 0 && (
        <section className="casual-wear-content section-py position-relative ">
          <div className="casual-wear-gradient position-absolute top-0 bottom-0 start-0 end-0"></div>
          <div className="white-layer position-absolute top-0 bottom-0 start-0 end-0"></div>
          <Container>
            <div className="grid align-items-center">
              <div className="g-col-12 g-col-xxl-3 order-xxl-1 d-xxl-flex align-items-xxl-center justify-content-xxl-center position-relative">
                <div className="arrow-shape d-none d-xxl-block">
                  <Image
                    src="/assets/images/whatsnew/casualwear/arrow-shape.svg"
                    className="position-static"
                    fill
                    loading="lazy"
                    alt="Arrow Shape Vector"
                  />
                </div>
                <div className="d-flex flex-row flex-xxl-column align-items-center justify-content-between justify-content-xxl-center">
                  <div className="d-inline-block">
                    <SectionHeading
                      title="Casual Wear"
                      className="orange-layer"
                    />
                  </div>
                  <div className="mt-xxl-5 text-xxl-center d-none d-sm-block">
                    {/* <ComanButton title="All Products" type="arrowshow" href="#" /> */}
                    {/* <ComanButton
                      title="All Products"
                      type="arrowshow"
                      href="/casual-wear-products"
                    /> */}
                    <CommonBtn
                      variant="hover-outline"
                      as={Link}
                      href="/casual-wear-products"
                      className="d-flex align-items-center position-relative px-3"
                    >
                      <span
                        className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                      >
                        All Products
                      </span>
                      <RightArrowIcon className="z-1" size={22} />
                    </CommonBtn>
                  </div>
                </div>
              </div>
              <div className="g-col-12 g-col-xxl-9 order-0">
                {/* <div className="custom-grid-four">
                <ProductCardSub data={casualwearcontent} type="gridview" className="d-flex align-items-center justify-content-center" />
              </div> */}
                <Swiper
                  slidesPerView={4}
                  loop={true}
                  autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                  }}
                  breakpoints={{
                    0: {
                      slidesPerView: 1,
                      centeredSlides: true,
                    },
                    640: {
                      slidesPerView: 2,
                      spaceBetween: 20,
                      centeredSlides: false,
                    },
                    768: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1200: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                    1400: {
                      slidesPerView: 3,
                      spaceBetween: 20,
                    },
                    1640: {
                      slidesPerView: 4,
                      spaceBetween: 20,
                    },
                  }}
                  modules={[Autoplay]}
                  className="mySwiper position-relative"
                >
                  {groupedProducts["Casual Wear"]?.products?.map((group, i) => {
                    return (
                      <>
                        <SwiperSlide key={`${i}c`}>
                          <ProductCardSub
                            data={group}
                            type="carouselview"
                            className="d-flex align-items-center justify-content-center"
                            onClick={handleQuickLook}
                          />
                        </SwiperSlide>
                      </>
                    );
                  })}
                </Swiper>
              </div>
              <div className="g-col-12 text-center d-sm-none">
                {/* <ComanButton title="All Products" type="arrowshow" href="#" /> */}
                <CommonBtn
                  variant="hover-outline"
                  // as={Link}
                  // href="/tunic-cord-set-products"
                  className="d-flex align-items-center position-relative px-3"
                >
                  <span
                    className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                  >
                    All Products
                  </span>
                  <RightArrowIcon className="z-1" size={22} />
                </CommonBtn>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* ------- Casual Wear Section End ------- */}

      {/* ------- First Offer Section Start ------- */}
      <section>
        {/* When there is no offer, the following will be displayed. */}
        {/* <Img
          src="/assets/images/whatsnew/firstoffer/banner-one.png"
          alt="Poster"
          className="d-inline-block object-fit-cover first-offer-baner"
        /> */}
        <Image
          src="/assets/images/whatsnew/firstoffer/banner-one.webp"
          alt="Poster"
          className="d-inline-block object-fit-cover first-offer-baner"
          width={1905}
          height={500}
          loading="lazy"
        />

        {/* The following is to be displayed when there is an offer. */}
        {/* <div className="bg-first-offer position-relative ">
          <Image
            src="/assets/images/whatsnew/firstoffer/offer-girl.webp"
            className="position-absolute ms-auto z-0 bottom-0 end-0 h-auto w-auto d-none  d-xl-block"
            fill
            alt="Offer Image"
          />
          <div>
            <h2 className="fw-normal">
              Flat <strong className="fw-semibold">25% off</strong> on
              Function’s Wear Saree
            </h2>
            <div className="mt-4 mt-xl-5">
              <ShopButton title="Shop Now" type="shopiconshow" href="#" />
            </div>
          </div>
        </div> */}
      </section>
      {/* ------- First Offer Section End ------- */}

      {/* ------- Latest Arrival Section Start ------- */}
      {latestProducts?.products?.length > 0 && (
        <section className="section-py position-relative">
          <Image
            src="/assets/images/whatsnew/latestarrival/new-shape.webp"
            className="position-absolute d-none d-xl-block new-shape w-auto h-auto"
            fill
            loading="lazy"
            alt="New Image Shape"
          />
          <Container>
            <SectionHeading title="Latest Arrival" className="red-layer" />
            <div className="pt-4 mt-1">
              <div className="custom-grid-five">
                <ProductCardMain
                  className="overflow-hidden cursor-pointer"
                  type="gridview"
                  productsGrid={latestProducts?.products}
                  onClick={handleQuickLook}
                />
              </div>
            </div>
            <div className="text-center mt-4 pt-1">
              {/* <ComanButton title="See All" href="/latest-arrival-products" /> */}
              <CommonBtn
                variant="hover-outline"
                as={Link}
                href="/latest-arrival-products"
                className="d-inline-flex position-relative px-3"
              >
                <span
                  className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                >
                  See All
                </span>
              </CommonBtn>
            </div>
          </Container>
        </section>
      )}

      {/* ------- Latest Arrival Section End ------- */}

      {/* ------- Tunic & Cord Set Section Start ------- */}
      {groupedProducts["Cord Set & Tunic"]?.products?.length > 0 && (
        <section className="tunicand-cord-content section-py position-relative">
          <div className="tunicand-cord-gradient position-absolute top-0 bottom-0 start-0 end-0"></div>
          <div className="white-layer position-absolute top-0 bottom-0 start-0 end-0"></div>
          <Container>
            <div className="d-flex align-items-center  justify-content-between">
              <SectionHeading
                title="Tunic & Cord Set"
                className="purple-layer"
              />
              <div className="d-none d-sm-block">
                {/* <ComanButton
                  title="All Products"
                  type="arrowshow"
                  href="/tunic-cord-set-products"
                /> */}
                <CommonBtn
                  variant="hover-outline"
                  as={Link}
                  href="/tunic-cord-set-products"
                  className="d-flex align-items-center position-relative px-3"
                >
                  <span
                    className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                  >
                    All Products
                  </span>
                  <RightArrowIcon className="z-1" size={22} />
                </CommonBtn>
              </div>
            </div>
            <div className="pt-4 mt-1">
              <div className="grid">
                <div className="d-none d-xxl-block g-col-xxl-3">
                  <div className=" d-flex align-items-center justify-content-center">
                    <Image
                      src="/assets/images/whatsnew/tunicandcirdset/main.webp"
                      className=" position-static h-auto w-auto img-fluid side-img object-fit-cover"
                      fill
                      alt="Tunic and Cordset Image"
                    />
                  </div>
                </div>
                <div className="g-col-12 g-col-xxl-9">
                  {/* <div className="custom-grid-four gap-3">
                    <ProductCardMain className="overflow-hidden" data={tunicandcordsetcontent} type="gridview" />
                  </div> */}
                  <CustomCarousel
                    slidesPerView={4}
                    items={groupedProducts["Cord Set & Tunic"]?.products || []}
                    loop={true}
                    autoplay={{
                      delay: 3000, // time in ms between slides
                      disableOnInteraction: false, // continue autoplay after user interactions
                    }}
                    modules={[Navigation, Autoplay]}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        centeredSlides: true,
                      },
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                        centeredSlides: false,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                      },
                      1200: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                      },
                      1400: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                      },
                      1640: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                      },
                    }}
                    renderItem={(item, i) => (
                      <ProductCardMain
                        products={item}
                        type="carouselview"
                        onClick={handleQuickLook}
                        key={i}
                      />
                    )}
                    className="mySwiper"
                    alterClass=""
                  />

                  {/* <Swiper
                    slidesPerView={4}
                    loop={true}
                    navigation={{
                      prevEl: prevRef.current,
                      nextEl: nextRef.current,
                    }}
                    onBeforeInit={(swiper) => {
                      swiper.params.navigation.prevEl = prevRef.current;
                      swiper.params.navigation.nextEl = nextRef.current;
                    }}
                    modules={[Navigation, Autoplay]}
                    autoplay={{
                      delay: 3000, // time in ms between slides
                      disableOnInteraction: false, // continue autoplay after user interactions
                    }}
                    breakpoints={{
                      0: {
                        slidesPerView: 1,
                        centeredSlides: true,
                      },
                      640: {
                        slidesPerView: 2,
                        spaceBetween: 16,
                        centeredSlides: false,
                      },
                      768: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                      },
                      1200: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                      },
                      1400: {
                        slidesPerView: 3,
                        spaceBetween: 16,
                      },
                      1640: {
                        slidesPerView: 4,
                        spaceBetween: 16,
                      },
                    }}
                    className="mySwiper"
                  >
                    {groupedProducts["Cord Set & Tunic"]?.products?.map(
                      (group, i) => {
                        return (
                          <SwiperSlide key={i}>
                            <ProductCardMain
                              products={group}
                              type="carouselview"
                              onClick={handleQuickLook}
                            />
                          </SwiperSlide>
                        );
                      }
                    )}
                  </Swiper> */}
                </div>
                <div className="g-col-12 text-center d-sm-none">
                  {/* <ComanButton title="All Products" type="arrowshow" href="#" /> */}
                  <CommonBtn
                    variant="hover-outline"
                    // as={Link}
                    // href="/tunic-cord-set-products"
                    className="d-flex align-items-center position-relative px-3"
                  >
                    <span
                      className={`fs-5 fw-normal text-capitalize z-1 text-nowrap`}
                    >
                      All Products
                    </span>
                    <RightArrowIcon className="z-1" size={22} />
                  </CommonBtn>
                </div>
              </div>
            </div>
          </Container>
        </section>
      )}

      {/* ------- Tunic & Cord Set Section End ------- */}

      {/* ------- Second Offer Section Start ------- */}
      <section>
        {/* When there is no offer, the following will be displayed. */}
        {/* <Img
          src="/assets/images/whatsnew/secondoffer/offer-poster.svg"
          className="object-fit-cover second-offer-poster d-inline-block"
          alt="Offer-Poster"
        /> */}
        <Image
          src="/assets/images/whatsnew/secondoffer/offer-poster.webp"
          className="object-fit-cover second-offer-poster w-100 img-fluid"
          alt="Offer-Poster"
          width={1905}
          height={750}
          sizes="(max-width: 768px) 100vw, 1905px"
        />

        {/* The following is to be displayed when there is an offer. */}
        {/* <div className="bg-secondoffer">
          <Container>
            <div className="grid align-items-center gap-0 gap-xl-4">
              <div className="g-col-12 g-col-xl-6 mx-auto mx-xl-0 d-none d-xl-block">
                <Image
                  src="/assets/images/whatsnew/secondoffer/offer-girl.png"
                  className="position-static offer-poster-woman"
                  fill
                  alt="Offer Image"
                />
              </div>
              <div className="g-col-12 g-col-xl-6">
                <div className="text-center mx-auto secondoffer-content">
                  <h2 className="fw-normal">
                    Flat <strong className="fw-semibold">50% off</strong> on
                    Western Wear
                  </h2>
                  <div className="d-flex flex-wrap align-items-center justify-content-center gap-4 mt-4 mt-lg-5 pt-2 pt-sm-3 pt-lg-0">
                    <div className="position-relative">
                      <Image
                        src="/assets/images/whatsnew/secondoffer/clock-shape.svg"
                        className="position-static clock-img h-auto w-auto"
                        fill
                        alt="Hour Clock Image"
                      />
                      <div className="position-absolute top-50 start-50  clock-counter text-center">
                        <h3 className="fw-semibold">{countdown.hours}</h3>
                        <span className="fw-normal">Hours</span>
                      </div>
                    </div>
                    <div className="position-relative">
                      <Image
                        src="/assets/images/whatsnew/secondoffer/clock-shape.svg"
                        className="position-static clock-img h-auto w-auto"
                        fill
                        alt="Hour Clock Image"
                      />
                      <div className="position-absolute top-50 start-50  clock-counter text-center">
                        <h3 className="fw-semibold">{countdown.minutes}</h3>
                        <span className="fw-normal">Minutes</span>
                      </div>
                    </div>
                    <div className="position-relative">
                      <Image
                        src="/assets/images/whatsnew/secondoffer/clock-shape.svg"
                        className="position-static clock-img h-auto w-auto"
                        fill
                        alt="Hour Clock Image"
                      />
                      <div className="position-absolute top-50 start-50  clock-counter text-center">
                        <h3 className="fw-semibold">{countdown.seconds}</h3>
                        <span className="fw-normal">Seconds</span>
                      </div>
                    </div>
                  </div>
                  <div className="mt-2 mt-sm-3 mt-lg-5 pt-4">
                    <ShopButton title="Shop Now" type="shopiconshow" href="#" />
                  </div>
                </div>
              </div>
            </div>
          </Container>
        </div> */}
      </section>
      {/* ------- Second Offer Section End ------- */}

      {/* ------- Blogs Section Start ------- */}
      {blogs?.length > 0 && (
        <section className="blogs-bg-img section-py">
          <Container fluid="md">
            <div className="text-center">
              <SectionHeading title="Blogs" className="blue-layer" />
            </div>
            <div className="row pt-4 mt-1 g-4 gap-lg-2">
              {blogs?.map((data, i) => (
                <Col key={i} xs={12} md={6} lg={4}>
                  <BlogCard item={data} />
                </Col>
              ))}
            </div>
          </Container>
        </section>
      )}
      {/* ------- Blogs Section End ------- */}

      {/* ------- Customer Feedback Section Start ------- */}
      <section className="customer-feedback-gradient section-py position-relative ">
        <div className="line-shape"></div>
        <Image
          src="/assets/images/whatsnew/customerfeedback/clap-shape.webp"
          className="position-absolute d-none d-xl-block clap-shape w-auto"
          fill
          alt="Clap Image Shape"
        />
        <Container fluid="sm">
          <div className="text-center">
            <SectionHeading
              title="Customer Review"
              className="orange-50-layer"
            />
          </div>
          <div className="pt-4 mt-1">
            <CustomCarousel
              slidesPerView={3}
              spaceBetween={40}
              items={customerfeedbackcontent}
              pagination={{
                clickable: true,
              }}
              autoHeight={false}
              modules={[Pagination]}
              loop={true}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                1640: {
                  spaceBetween: 40,
                },
              }}
              renderItem={(item, i) => (
                <CustomerFeedbackCard data={item} key={i} />
              )}
              className="mySwiper"
              alterClass=""
            />

            {/* <Swiper
              slidesPerView={3}
              spaceBetween={40}
              autoHeight={false}
              pagination={{
                clickable: true,
              }}
              loop={true}
              modules={[Pagination]}
              breakpoints={{
                0: {
                  slidesPerView: 1,
                },
                850: {
                  slidesPerView: 2,
                  spaceBetween: 24,
                },
                1200: {
                  slidesPerView: 3,
                  spaceBetween: 24,
                },
                1640: {
                  spaceBetween: 40,
                },
              }}
              className="mySwiper"
            >
              {customerfeedbackcontent.map((item, i) => {
                return (
                  <SwiperSlide key={`${i}e`}>
                    <CustomerFeedbackCard data={item} />
                  </SwiperSlide>
                );
              })}
            </Swiper> */}
          </div>
        </Container>
      </section>
      {/* ------- Customer Feedback Section End ------- */}
      {reelModal && (
        <ReelPopup
          show={reelModal}
          onHide={closeReelModal}
          allVideos={videos?.data || {}}
          // videoSrc={
          //   activeReel !== null ? videos?.data[activeReel]?.video_url : ""
          // }
          products={
            activeReel !== null ? videos?.data[activeReel]?.products : []
          }
          // onPrev={prevReel}
          // onNext={nextReel}
          hasMultiple={videos?.data?.length > 1}
          activeReel={activeReel}
          setActiveReel={setActiveReel}
        />
      )}

      <QuickLookPopup
        show={showQuickLook}
        onHide={handleCloseQuickLook}
        fullscreen="md-down"
        product={product}
      />
    </div>
  );
}
